import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBorderAll, faList } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "../scss/_resources.scss";

function ResourceList() {
    const [toggleView, setToggleView] = useState("list");
    const { i18n } = useTranslation();
    const resourceArray = i18n.getResourceBundle(
        i18n.language,
        "resourcesContainer"
    );
    const resourceData = resourceArray.resources;
    const resourceTitle = resourceArray.heading;

    return (
        <div className="resources">
            <div className="heading">
                <h1>{resourceTitle}</h1>
            </div>
            <div className="research-bar">
                <motion.button
                    title="Grid View"
                    onClick={() => setToggleView("list")}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                >
                    <FontAwesomeIcon
                        icon={faList}
                        className={
                            "icon " + (toggleView == "list" ? "selected" : "")
                        }
                    />
                </motion.button>
                <motion.button
                    title="List View"
                    onClick={() => setToggleView("grid")}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                >
                    <FontAwesomeIcon
                        icon={faBorderAll}
                        className={
                            "icon " + (toggleView == "grid" ? "selected" : "")
                        }
                    />
                </motion.button>
            </div>

            <div className={toggleView == "list" ? "listView" : "gridView"}>
                {resourceData.map((resource) => (
                    <Link
                        to={`/Resources/${resource.id}`}
                        key={resource.id}
                        className={
                            toggleView == "list"
                                ? "listContainer"
                                : "gridContainer"
                        }
                    >
                        <div className="image-wrapper">
                            <img
                                src={resource.image}
                                alt={resource.title}
                                className="image"
                            />
                        </div>

                        <div className="textContainer">
                            <div className="title">{resource.title}</div>
                            <div className="description">
                                {resource.description}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default ResourceList;


// Code down here is for usability with DB data. But DB connection doesn't work as 
// the DB isn't accessible as Dal mongo is on a private network.

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBorderAll, faList } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import "../scss/_resources.scss";

// function ResourceList() {
//     const [toggleView, setToggleView] = useState("list");
//     const [resourceData, setResourceData] = useState([]);
//     const resourceTitle = "Resources";

//     useEffect(() => {
//         // Fetch data from the backend
//         axios.get("http://localhost:5001/api/resources")
//             .then(response => {
//                 setResourceData(response.data);
//             })
//             .catch(error => {
//                 console.error("There was an error fetching the resource data!", error);
//             });
//     }, []);

//     return (
//         <div className="resources">
//             <div className="heading">
//                 <h1>{resourceTitle}</h1>
//             </div>
//             <div className="research-bar">
//                 <motion.button
//                     title="Grid View"
//                     onClick={() => setToggleView("list")}
//                     whileHover={{ scale: 1.2 }}
//                     whileTap={{ scale: 0.9 }}
//                 >
//                     <FontAwesomeIcon
//                         icon={faList}
//                         className={
//                             "icon " + (toggleView === "list" ? "selected" : "")
//                         }
//                     />
//                 </motion.button>
//                 <motion.button
//                     title="List View"
//                     onClick={() => setToggleView("grid")}
//                     whileHover={{ scale: 1.2 }}
//                     whileTap={{ scale: 0.9 }}
//                 >
//                     <FontAwesomeIcon
//                         icon={faBorderAll}
//                         className={
//                             "icon " + (toggleView === "grid" ? "selected" : "")
//                         }
//                     />
//                 </motion.button>
//             </div>

//             <div className={toggleView === "list" ? "listView" : "gridView"}>
//                 {resourceData.map((resource) => (
//                     <Link
//                         to={`/Resources/${resource._id}`}
//                         key={resource._id}
//                         className={
//                             toggleView === "list"
//                                 ? "listContainer"
//                                 : "gridContainer"
//                         }
//                     >
//                         <img
//                             src={resource.image.url}
//                             alt={resource.image.altText}
//                             className="image"
//                         />
//                         <div className="textContainer">
//                             <div className="title">{resource.title}</div>
//                             <div className="description">
//                                 {resource.description}
//                             </div>
//                         </div>
//                     </Link>
//                 ))}
//             </div>
//         </div>
//     );
// }

// export default ResourceList;